<div class="component-save">
	<div class="component-save-content" (click)="on_click()"  >
		<div class="button-save-title" i18n>Sauvegarder</div>
		<button mat-mini-fab color="primary" [disabled]="disabled" class="button-save-icon">
			<mat-icon>save</mat-icon>
		</button>
	</div>
</div>
